import { Component, OnInit, Inject } from '@angular/core';
import {Location} from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EsquemaInversionService } from '../../../../services/esquema-inversion.service';

@Component({
  selector: 'app-eliminar-esquema-modal',
  templateUrl: './eliminar-esquema-modal.component.html',
  styleUrls: ['./eliminar-esquema-modal.component.scss']
})
export class EliminarEsquemaModalComponent implements OnInit {

  constructor(
    public location : Location,
    public dialogRef: MatDialogRef<EliminarEsquemaModalComponent>,
    private esquemaInversionService: EsquemaInversionService,
    @Inject (MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {
    console.error(this.data)
  }

  public close(){
    this.dialogRef.close({incremento:false})
  }

  public eliminar(){
    console.log(this.data.idEsquema)
    this.esquemaInversionService.eliminarEsquema({id:this.data.idEsquema}).subscribe(
      (response)=>{
        console.info("Success")
        this.location.back()
      },
      (error)=>{
        console.error("Fail")
        // this.location.back()
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/detalles-inversion/eliminar-esquema-modal/eliminar-esquema-modal.component.ts